import React from 'react';
import { CheckCircle, Search, Users, Clock, Shield } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ForEmployersPage() {
  return <div className="pt-20" data-id="element-447">
      {/* Hero */}
      <section className="bg-navy-900 text-white py-20" data-id="element-448">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-449">
          <div data-id="element-450">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-451">
              Find Your Next{' '}
              <span className="text-gold-500" data-id="element-452">Star Employee</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8" data-id="element-453">
              We connect world-class companies with pre-screened, high-impact
              talent. Reduce your time-to-hire and increase retention.
            </p>
            <Button variant="gold" size="lg" href="/contact" data-id="element-454">
              Request Talent
            </Button>
          </div>
          <div className="relative" data-id="element-455">
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Office meeting" className="rounded-lg shadow-2xl" data-id="element-456" />
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-lg shadow-xl hidden md:block" data-id="element-457">
              <div className="text-4xl font-bold text-navy-900" data-id="element-458">95%</div>
              <div className="text-gray-600" data-id="element-459">Retention Rate</div>
            </div>
          </div>
        </div>
      </section>

      {/* Value Props */}
      <section className="py-20 bg-white" data-id="element-460">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-461">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-462">
            {[{
            icon: Clock,
            title: 'Speed',
            desc: 'Candidates presented within 48 hours.'
          }, {
            icon: Search,
            title: 'Vetting',
            desc: 'Rigorous 5-step screening process.'
          }, {
            icon: Users,
            title: 'Quality',
            desc: 'Top 1% of talent in your industry.'
          }, {
            icon: Shield,
            title: 'Guarantee',
            desc: '90-day replacement guarantee.'
          }].map((item, index) => <div key={index} className="text-center p-6 border border-gray-100 rounded-xl hover:shadow-lg transition-shadow" data-id="element-463">
                <item.icon className="h-10 w-10 text-gold-500 mx-auto mb-4" data-id="element-464" />
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-465">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-466">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="py-20 bg-gray-50" data-id="element-467">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-468">
          <h2 className="text-3xl font-serif font-bold text-navy-900 mb-12" data-id="element-469">
            Industries We Serve
          </h2>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-470">
            {['Technology', 'Finance', 'Healthcare', 'Marketing', 'Engineering', 'Sales', 'Human Resources', 'Operations'].map((ind, i) => <span key={i} className="bg-white px-6 py-3 rounded-full shadow-sm text-navy-900 font-medium border border-gray-200" data-id="element-471">
                {ind}
              </span>)}
          </div>
        </div>
      </section>

      {/* Simple Contact Form for Employers */}
      <section className="py-20" data-id="element-472">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-473">
          <div className="bg-navy-900 rounded-2xl p-8 md:p-12 text-white text-center" data-id="element-474">
            <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-475">
              Start Hiring Today
            </h2>
            <p className="mb-8 text-gray-300" data-id="element-476">
              Tell us about your open roles and we'll be in touch within 24
              hours.
            </p>
            <Button variant="gold" size="lg" href="/contact" data-id="element-477">
              Contact Our Sales Team
            </Button>
          </div>
        </div>
      </section>
    </div>;
}